// extracted by mini-css-extract-plugin
module.exports = {"mail_status_list":"mailStatusList_mail_status_list__zb9gQ","mail_status_export":"mailStatusList_mail_status_export__2qR2A"};